// extracted by mini-css-extract-plugin
export default {"mainContainer":"Container_mainContainer__Kj-1t","container":"Container_container__GUjyn","sm":"Container_sm__MID-E"};